<template>
  <table class="info-table table table-sm mb-0">
    <tr>
      <th class="border-top-0">{{ $t('Percentage') }}</th>
      <th class="border-top-0" v-if="calculatedCommissions.length > 1">{{ $t('Over') }}</th>
    </tr>
    <tr v-for="(commission, index) in calculatedCommissions" :key="index">
      <td>{{ commission.percent | round }} %</td>
      <td v-if="calculatedCommissions.length > 1">{{ (commission.amount_over || 0) | asCurrency }}</td>
    </tr>
  </table>
</template>

<script>
  import helperService from "@/core/services/helper.service";
  import cloneDeep from "lodash/cloneDeep";

  export default {
    name: "CommissionsViewTable",
    props: {
      commissions: {
        required: true
      },
      taxRate: {
        type: Number,
        default: null
      }
    },
    computed: {
      calculatedCommissions() {
        let data = helperService.reverseCalculateTiers({commissions: cloneDeep(this.commissions)}, this.taxRate)
        return data.commissions
      }
    }
  }
</script>

<style scoped>

</style>
